<template>
    <div>
        <h3>
            Aprobamos tu credito en 5 minutos.
        </h3>
        <h4>
            <span>
                Financiamos a la medida con las mejores tasas para usados del
                mercado.
            </span>
        </h4>
        <ul class="list_style_none">
            <li>
                <i aria-hidden="true" class="fa fa-check"></i>
                Fácil , flexible y de acuerdo a tu necesidad
            </li>
            <li>
                <i aria-hidden="true" class="fa fa-check"></i>
                Planes y alternativas de acuerdo a su capacidad de pago
            </li>
            <li>
                <i aria-hidden="true" class="fa fa-check"></i>
                Trabajamos de la mano con todos los bancos
            </li>
        </ul>
            <div class="text-center">
                <div class="form-group col-md-12 col-sm-12">
                    <label class="form-label">
                        <h6 class="mb-0">
                            Calcula el valor de tu cuota mensual
                        </h6>
                    </label>
                    <h6 class="text-small text-muted mb-0 mt-0">
                        <small>Plazo en meses</small>
                    </h6>
                    <div class="btn-group" role="group">
                        <button
                            type="button"
                            @click="mesesSelect = 24"
                            :class="{ active: mesesSelect === 24 }"
                            class="btn btn-credit"
                        >
                            24
                        </button>
                        <button
                            type="button"
                            @click="mesesSelect = 48"
                            :class="{ active: mesesSelect === 48 }"
                            class="btn btn-credit"
                        >
                            48
                        </button>
                        <button
                            type="button"
                            @click="mesesSelect = 60"
                            :class="{ active: mesesSelect === 60 }"
                            class="btn btn-credit"
                        >
                            60
                        </button>
                        <button
                            type="button"
                            @click="mesesSelect = 72"
                            :class="{ active: mesesSelect === 72 }"
                            class="btn btn-credit"
                        >
                            72
                        </button>
                        <button
                            type="button"
                            @click="mesesSelect = 84"
                            :class="{ active: mesesSelect === 84 }"
                            class="btn btn-credit"
                        >
                            84
                        </button>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12">
                    <label class="form-label m-0 text-muted">
                        Tasas para usados desde el
                        <b>0.99%</b>
                        <h6 class="m-0">
                            Cuota Mensual $ {{ calculateCuotaMensual() }}
                        </h6>
                    </label>
                </div>
                <div class="col-md-12 col-12">
                    <b-button
                        variant="dark"
                        class="mt-4 text-uppercase"
                        block
                        @click="sendFinanciar"
                        >Solicitar Credito</b-button
                    >
                </div>
            </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
    computed: {
        ...mapFields("fichaTecnica", [
            "vehiculo.info_vehiculo",
            "vehiculoSimilares"
        ]),
        idReporte() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo.id_reporte;
        },
    },
    data() {
        return {
            mesesSelect: 84
        };
    },
    methods: {
        calculateCuotaMensual() {
            var monto = this.info_vehiculo.vehiculo.precio_publicacion;
            var tasa = 1.2;
            var tasa = tasa / 100.0;
            var cuota =
                monto *
                ((tasa * Math.pow(1 + tasa, this.mesesSelect)) /
                    (Math.pow(1 + tasa, this.mesesSelect) - 1));
            cuota = cuota.toFixed(0);
            var toInt = parseInt(cuota);
            return toInt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        sendFinanciar() {
            window.location.href = "/financiar?step=1&ficha_tecnica=" + this.idReporte;
        }
    }
};
</script>

<style lang="scss">
button.btn.btn-credit {
    background: #dcdcdc;
    color: #000;
}
button.btn.btn-credit.active {
    background-color: #fa2837 !important;
    color: #fff;
}
</style>
